import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { getAllDataFromLocalForage, default as localForage } from 'ngrx-store-persist';

getAllDataFromLocalForage({
  driver: localForage.LOCALSTORAGE,
  keys: ['fcm', 'auth'],
}).then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
